import React from "react";
import { connect } from "react-redux";
import * as Type from "@interface/index";
import * as Model from "@models/index";
import * as Middleware from "@middlewares/index";
import HTMLReactParser, { DOMNode } from "html-react-parser";
import { Link } from "react-router-dom";

interface PropsInterface extends Type.ComponentInterface {}

interface StateInterface {
  login: string;
}

class SignUpPage extends React.Component<PropsInterface, StateInterface> {
  public constructor(props: PropsInterface) {
    super(props);
    this.state = {
      login: "",
    };
    this.onSubmitHandler = this.onSubmitHandler.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
  }

  public componentDidMount() {
    document.title = "Signup" + " | " + process.env.SITE_NAME;
    this.props.Dispatch(Middleware.Ui.Footer.hide());
  }

  private onSubmitHandler(event: React.FormEvent<HTMLFormElement>): void {
    event.preventDefault();
    this.props.Dispatch(
      Middleware.Auth.passwordRestore(this.state, () => {
        this.props.history.push("/static/registration-complete");
      })
    );
  }

  private onChangeHandler(event: React.ChangeEvent<HTMLInputElement>): void {
    this.setState({ [event.target.name]: event.target.value });
  }

  public render() {
    return (
      <div className="auth auth--restore">
        <div className="auth__wrapper">
          <Link to="/auth/signin" className="auth__close" />
          <div className="auth__body">
            <h1>Забыли пароль?</h1>
            <div className="auth__header-desc">
              Обновить пароль просто. Напишите email, с которого
              вы регистрировались на онлайн-выставку, и мы отправим Вам письмо
              с ссылкой для сброса старого пароля.
            </div>

            <form onSubmit={this.onSubmitHandler}>
              <div className="auth__input">
                <input
                  className="input"
                  type="email"
                  name="login"
                  id="login"
                  value={this.state.login}
                  onChange={this.onChangeHandler}
                  placeholder="Email"
                  required={true}
                />
                {/* <button
                    type="submit"
                    className="auth__btn auth__btn--blue-white"
                  >
                    ОК
                  </button> */}
                <div className="auth__footer w-fit">
                  <button className="btn btn--blue auth__btn" type="submit">
                    Сбросить пароль
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (Store: any) => {
    return { Store };
  },
  (Dispatch: (action: any) => void) => {
    return { Dispatch: (action: any) => Dispatch(action) };
  }
)(SignUpPage);
